const BUUKD_SUPPORT_WHATSAPP_URL = "https://wa.me/233541273802";

export function openBuukdSupportWhatsApp(message = "Hi Buukd support, I need help with my account access."): void {
  const url = `${BUUKD_SUPPORT_WHATSAPP_URL}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
